import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

class Section extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "business",
    };
  }

  getImage = () => {
    const { active } = this.state;

    if (active === "payroll") return "/payroll-screen.png";
    if (active === "accounting") return "/acc-page.png";
    return "/emp-page.png";
  };

  render() {
    const { active } = this.state;

    return (
      <>
        <section className="pwlp-hero" id="home">
          <Container className="pwlp-hero__container">
            <Row className="justify-content-center">
              <Col lg="10" xl="8" className="text-center">
                <h3 className="pwlp-hero__title">
                  Not Just Balanced.
                  <br />
                  Accounted to the Penny.
                </h3>

                <p className="pwlp-hero__desc">
                  Precision-driven accounting that goes beyond the books—uncovering
                  insights, ensuring every cent tells the truth.
                </p>

                <div className="pwlp-hero__actions">
                  <a href="#services" className="pwlp-hero__learn-btn">
                    Learn More
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="pwlp-gradient-section">
          <div className="pwlp-hero__cutout">
            <div className="pwlp-hero__chips">
              <button
                type="button"
                className={`pwlp-hero__chip ${
                  active === "business" ? "pwlp-hero__chip--active" : ""
                }`}
                onClick={() => this.setState({ active: "business" })}
              >
                Employees
              </button>

              <button
                type="button"
                className={`pwlp-hero__chip ${
                  active === "payroll" ? "pwlp-hero__chip--active" : ""
                }`}
                onClick={() => this.setState({ active: "payroll" })}
              >
                Payroll
              </button>

              <button
                type="button"
                className={`pwlp-hero__chip ${
                  active === "accounting" ? "pwlp-hero__chip--active" : ""
                }`}
                onClick={() => this.setState({ active: "accounting" })}
              >
                Accounting
              </button>
            </div>
          </div>

          <div className="pwlp-hero__preview">
            <img
              src={this.getImage()}
              alt="preview"
              className="pwlp-hero__preview-img"
            />
          </div>
        </section>
      </>
    );
  }
}

export default Section;



// import React, { Component } from "react";
// import { Container, Row, Col } from "reactstrap";

// class Section extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       active: "business",
//     };
//   }

//   getImage = () => {
//     const { active } = this.state;

//     if (active === "payroll") return "/dashdark.png";
//     if (active === "accounting") return "/dashdark.png";
//     return "/dash.png";
//   };

//   render() {
//     const { active } = this.state;

//     return (
//       <section className="pwlp-hero" id="home">
//         <Container className="pwlp-hero__container">
//           <Row className="justify-content-center">
//             <Col lg="10" xl="8" className="text-center">
//               <h3 className="pwlp-hero__title">
//                 Not Just Balanced.
//                 <br />
//                 Accounted to the Penny.
//               </h3>

//               <p className="pwlp-hero__desc">
//                 Precision-driven accounting that goes beyond the books—uncovering
//                 insights, ensuring every cent tells the truth.
//               </p>

//               <div className="pwlp-hero__actions">
//                 <a href="#services" className="pwlp-hero__learn-btn">
//                   Learn More
//                 </a>
//               </div>
//             </Col>
//           </Row>
//         </Container>

        

//         <div className="pwlp-hero__cutout">
//           <div className="pwlp-hero__chips">
//             <button
//               type="button"
//               className={`pwlp-hero__chip ${active === "business" ? "pwlp-hero__chip--active" : ""}`}
//               onClick={() => this.setState({ active: "business" })}
//             >
//               Business page
//             </button>

//             <button
//               type="button"
//               className={`pwlp-hero__chip ${active === "payroll" ? "pwlp-hero__chip--active" : ""}`}
//               onClick={() => this.setState({ active: "payroll" })}
//             >
//               Payroll
//             </button>

//             <button
//               type="button"
//               className={`pwlp-hero__chip ${active === "accounting" ? "pwlp-hero__chip--active" : ""}`}
//               onClick={() => this.setState({ active: "accounting" })}
//             >
//               Accounting
//             </button>
//           </div>
//         </div>

//         <section className="pwlp-gradient-section">
//   <div className="pwlp-hero__cutout">
//     <div className="pwlp-hero__chips">
//       <button className="pwlp-hero__chip pwlp-hero__chip--active">
//         Business page
//       </button>
//       <button className="pwlp-hero__chip">Payroll</button>
//       <button className="pwlp-hero__chip">Accounting</button>
//     </div>
//   </div>

//   <div className="pwlp-hero__preview">
//     <img
//       src={this.getImage()}
//       alt="preview"
//       className="pwlp-hero__preview-img"
//     />
//   </div>
// </section>
//       </section>
      
//     );
//   }
// }

// export default Section;


// import React, { Component } from "react";
// import { Container, Row, Col } from "reactstrap";

// class Section extends Component {
//   render() {
//     return (
//       <section className="pwlp-hero" id="home">
//         <Container className="pwlp-hero__container">
//           <Row className="justify-content-center">
//             <Col lg="10" xl="8" className="text-center">
//               <h3 className="pwlp-hero__title">
//                 Not Just Balanced.
//                 <br />
//                 Accounted to the Penny.
//               </h3>

//               <p className="pwlp-hero__desc">
//                 Precision-driven accounting that goes beyond the books—uncovering
//                 insights, ensuring every cent tells the truth.
//               </p>

//               <div className="pwlp-hero__actions">
//                 <a href="#services" className="pwlp-hero__learn-btn">
//                   Learn More
//                 </a>
//               </div>
//             </Col>
//           </Row>
//         </Container>

//         <div className="pwlp-hero__gradient"></div>

// <div className="pwlp-hero__cutout">
//   <div className="pwlp-hero__chips">
//     <span className="pwlp-hero__chip pwlp-hero__chip--active">Business page</span>
//     <span className="pwlp-hero__chip">Payroll</span>
//     <span className="pwlp-hero__chip">Accounting</span>
//   </div>
// </div>
//       </section>
//     );
//   }
// }

// export default Section;



// import React, { Component } from "react";

// import { Container, Row, Col } from "reactstrap";



// class Section extends Component {
//   constructor() {
//     super();
//     this.state = {
//       isOpen: false,
//     };
    
//   }

  

//   render() {
//     return (
//       <React.Fragment>
//         <section className="section bg-home vh-100" id="home">
//           <div className="bg-overlay"></div>
//           <div className="display-table">
//             <div className="display-table-cell">
//               <Container>
//                 <Row>
//                   <Col
//                     lg={{ size: 8, offset: 2 }}
//                     className="text-white text-center"
//                   >
                    
//                     <h3 className="home-title">
//                     "Not Just Balanced. Accounted to the Penny."
//                     </h3>
//                     <p className="pt-3 home-desc mx-auto">
//                     Precision-driven accounting that goes beyond the books - uncovering insights, ensuring every cent tells the truth.
//                     </p>
                    
//                   </Col>
                 
                  
//                 </Row>
//               </Container>
//             </div>
//           </div>
//         </section>
//       </React.Fragment>
//     );
//   }
// }

// export default Section;
